<template>
  <container-slot>
    <v-col cols="12">
      <h1 class="display-1 font-weight-medium">Add New Role</h1>
    </v-col>
    <v-col cols="12" md="4" v-show="successSubmit">
      <v-alert
        :type="!error ? `success` : `error`"
        ref="alert"
        dismissible
        @input="close"
        class="noMarg"
        v-show="successSubmit"
      >
        {{ msg }}
      </v-alert>
    </v-col>
    <v-col cols="12" md="4" v-show="successSubmit"></v-col>
    <v-col cols="12" md="4" v-show="successSubmit"></v-col>
    <v-col cols="12" md="4">
      <v-form ref="form" v-model="valid" @submit="submit">
        <v-text-field
          prepend-inner-icon="mdi-pencil"
          name="rolename"
          label="Role Name"
          id="rolename"
          type="text"
          v-model="roleName"
          :rules="roleNameRules"
          ref="roleNameInput"
          outlined
          required
        >
        </v-text-field>
        <v-btn
          :disabled="!valid || loading"
          color="primary"
          @click="submit"
          ref="submitBtn"
          :loading="loading"
        >
          Submit
        </v-btn>
      </v-form>
    </v-col>
  </container-slot>
</template>

<script>
import ContainerSlot from "@/components/ContainerSlot";
// import { lsUtils } from "@/utils/localStorageUtils";
import { insertRole } from "@/utils/graphqlMutation";
import { roles } from "@/utils/graphqlQuery";
export default {
  data() {
    return {
      btnHtml: "Submit",
      error: false,
      msg: "",
      loading: false,
      roleName: "",
      roleNameRules: [
        (v) => !!v || "Role Name is required",
        (v) => /^[A-Za-z0-9 ]{1,}$/.test(v) || "Role Name must be valid",
      ],
      successSubmit: false,
      valid: false,
    };
  },
  components: {
    ContainerSlot,
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      // const { token, data: userData } = lsUtils.getItem("userToken");
      this.successSubmit = false;
      const gqlRoles = roles;
      if (this.valid) {
        this.loading = true;
        try {
          const { data } = await this.$apollo.mutate({
            mutation: insertRole,
            variables: {
              roleName: this.roleName,
            },
            update: (store, { data: { insertRole: roleData } }) => {
              try {
                const cachedRoles = store.readQuery({ query: gqlRoles });
                cachedRoles.roles.push(roleData.data);
                store.writeQuery({
                  query: gqlRoles,
                  data: {
                    roles: cachedRoles,
                  },
                });
                return roleData.data;
              } catch (err) {
                // eslint-disable-next-line no-console
                console.log('No "roles" cache found');
                return null;
              }
            },
          });
          const { success, msg } = data.insertRole;
          if (!success) {
            throw new Error(msg);
          }
          this.error = false;
          this.msg = msg;
          this.reset();
        } catch (error) {
          this.error = true;
          this.msg = error.message;
        } finally {
          this.successSubmit = true;
          this.loading = false;
        }
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    close() {
      this.successSubmit = false;
    },
  },
  name: "AddRole",
  title() {
    return "Add New Role";
  },
};
</script>

<style scoped>
.noMarg {
  margin: 0;
}
</style>
